import config from "config";
import { APP_ROUTES } from "const";
import { memo } from "react";
import { Link } from "react-router-dom";
import notFoundImg from "assets/images/404.svg";

function NotFound() {
  const contactUsURL =
    config.VERTICAL === "METAVERSE"
      ? "https://metaverseinsider.tech/contact-us/"
      : "https://thequantuminsider.com/contact-us/";
  return (
    <div className="flex flex-col w-full h-full flex-wrap content-center justify-around">
      <div className="flex justify-around flex-wrap align-center content-center justify-center max-w-[600px] p-[60px]">
        <img src={notFoundImg} alt="notFoundImg" className="flex mb-[12px]" />
        <div className="flex text-primary text-[20px] font-bold pb-[8px] w-[100%] justify-center">
          Page not found
        </div>
        <div className="text-[#98A0A6] text-[14px] w-[100%] justify-center align-center text-center">
          Oh, we can't seem to find the page you're looking for. Try going back
          to the previous page or see our{" "}
          <a
            className="text-primaryBlue text-[14px] font-bold"
            href={contactUsURL}
          >
            Help Center
          </a>{" "}
          for more information
        </div>
        <Link
          to={APP_ROUTES.DASHBOARD}
          className="no-underline flex flex-wrap bg-[#00649c] rounded-[4px] w-[160px] h-[40px] text-white text-[12px] align-center content-center justify-center mt-[24px]"
        >
          Go to my feed
        </Link>
      </div>
    </div>
  );
}

export default memo(NotFound);
